module.exports = __webpack_public_path__ + "img/close.a5dca711.svg";